export default __webpack_public_path__ + "static/media/UWflow++.2b96a316.png";